function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".super_llama_svg__cls-3{fill:#ff7011}.super_llama_svg__cls-4{fill:#38434a}.super_llama_svg__cls-5{fill:#303030}.super_llama_svg__cls-9{fill:#3b6580}.super_llama_svg__cls-11{fill:#2f5065}.super_llama_svg__cls-16{fill:#0f83ac}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "super_llama_svg__Capa_2",
  "data-name": "Capa 2"
}, React.createElement("g", {
  id: "super_llama_svg__Capa_1-2",
  "data-name": "Capa 1"
}, React.createElement("path", {
  fill: "#ff912a",
  d: "M52.45 35.08l-1.24.24-16.44-2.57H21.23l-2.38-6.24-.56-1.46-1.03-2.7 3.09-1.13 5.93-2.16 2.28-3.49 4.59-1.06-3.94-6.43L30.24.46l.93-.46 8.62 14.24 1.21.13L38.51 8l2.2-6.42.62-.54 5.4 15.52 5.72 18.52z"
}), React.createElement("path", {
  fill: "#ff9629",
  d: "M53.7 45l-22.91.85 20.42-10.53L53.7 45z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-3",
  d: "M51.21 35.32L30.78 45.86l3.99-13.11 16.44 2.57z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-4",
  d: "M75.17 54.48l-5.25.11L105.34 116l18.87 5.06-49-66.58m-17.61.38l-6 .15 26.82 63 18.72 4.19 1-.88z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-5",
  d: "M51.59 55l-25.87.61 23.2 74.57 28.8-12.33.69.15zM69.92 54.59l-12.36.27 40.59 66.46 6.62-5.51.57.19z"
}), React.createElement("path", {
  d: "M72.78 167.93l-.57-2.4-14 3 21 40.48z",
  fill: "#005b78"
}), React.createElement("path", {
  d: "M31.5 162.56l.11-.49-14.49-43.87-2.85 87.66 17.23-43.3m29.67-42l-22.59 10.12 19.63 37.89 3-48m-.3-5.1L41.66 86.32l-7.84-2.51-18.72 4.91 2.17 23 43.6 3.69m.34-58.32v18.83L75 53.68l-.53.12-13.26 3.34m-.15 19.18l-.27.38.38.3.08-.42h.19l-.19-.12V76l-.19.35M9.43 71.9L8.1 51.63 0 87.77h1.07l50.14-17.31-17.58 1.06-16.93 1.41L9.32 72z",
  fill: "#0097c8"
}), React.createElement("path", {
  d: "M38.31 130.8v-.12L17.12 118.2l14.49 43.87z",
  fill: "#006e8f"
}), React.createElement("path", {
  className: "super_llama_svg__cls-9",
  d: "M15.1 88.72l18.72-4.91.46-.15 16.93-13.2L1.07 87.81l14 .45z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-4",
  d: "M61.17 120.56l.19-.11-.68-2.86.19-2.13-43.6-3.69v.46l-.19 6 21.23 12.48.07-.3.16.3 22.59-10.12M35.76 63.23l.31-.08.53-.15 15.63-18.75-21 .11-22.79 7z"
}), React.createElement("path", {
  d: "M61.36 120.45l-.19.11-3 48 14-3z",
  fill: "#467896"
}), React.createElement("path", {
  className: "super_llama_svg__cls-11",
  d: "M60.87 115.46L63 93.21l-21.3-6.89z"
}), React.createElement("path", {
  d: "M79.82 91.15V91l-45.54-7.3-.46.15 7.84 2.51L63 93.21V93z",
  fill: "#416e87"
}), React.createElement("path", {
  d: "M61.25 76.58l-.08.42 18.65 14-4.68-37.28h-.12L61.25 76v.46l.19.12z",
  fill: "#006988"
}), React.createElement("path", {
  d: "M61.17 77l-.38-.3-26.51 7L79.82 91z",
  fill: "#4bb2d8"
}), React.createElement("path", {
  d: "M51.55 70.46h-.34l-16.93 13.2 26.51-7 .27-.38z",
  fill: "#2f4f63"
}), React.createElement("path", {
  className: "super_llama_svg__cls-16",
  d: "M36.07 63.15l-2.44 8.37 17.58-1.06h.34l9.51 5.86.19-.35V57.14l-.57.16.57-.27L36.6 63z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-5",
  d: "M53.6 44.25h-1.37L36.6 63l24.61-6-.57.27.57-.16 13.28-3.31.15-.31z"
}), React.createElement("path", {
  d: "M8.41 51.36l-.23.08 9 16.7L20 67l13.66 4.49 2.44-8.37-.31.08z",
  fill: "#64c3e4"
}), React.createElement("path", {
  d: "M9.43 71.9l-.11.1 7.38 1 16.93-1.41L20 67l-2.8 1.14z",
  fill: "#85d6f3"
}), React.createElement("path", {
  className: "super_llama_svg__cls-9",
  d: "M8.1 51.63L9.43 71.9l7.77-3.76-9-16.7zM15.1 88.72l18.72-4.91.46-.15 16.93-13.2L1.07 87.81l14 .45z"
}), React.createElement("path", {
  d: "M61.36 120.45l-.19.11-3 48 14-3-9.89-41.09z",
  fill: "#01789b"
}), React.createElement("path", {
  d: "M61.36 120.45l-.68-2.86.19-2.13-43.6-3.69v.46l-.19 6 21.23 12.48.07-.3.16.3 22.59-10.12z",
  fill: "#3e454b"
}), React.createElement("path", {
  className: "super_llama_svg__cls-11",
  d: "M60.87 115.46L63 93.21l-21.3-6.89z"
}), React.createElement("path", {
  d: "M79.74 91.15h.08V91l-45.54-7.3-.46.15 7.84 2.51L63 93.21V93l4.57-.5z",
  fill: "#076e8a"
}), React.createElement("path", {
  className: "super_llama_svg__cls-16",
  d: "M36.07 63.15l-2.44 8.37 17.58-1.06h.34l9.51 5.86.19-.35V57.14l-.57.16.57-.27L36.6 63z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-9",
  d: "M8.18 51.44l-.08.19L9.43 71.9l7.77-3.76z"
}), React.createElement("path", {
  fill: "#3a383b",
  d: "M29.5 16.36l6.66 2.53-.28 3.73-7.79.6L24.28 21l3.13-1.32 2.09-3.32z"
}), React.createElement("path", {
  className: "super_llama_svg__cls-3",
  d: "M21.03 23.02l-.68 3.49-1.33.45-.73-1.91-1.03-2.7 3.77.67z"
})));

var SvgSuperLlama = function SvgSuperLlama(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 124.21 209.05"
  }, props), _ref, _ref2);
};

export default SvgSuperLlama;